import React from 'react'

const ESTADOS = {
  pendiente: { label: 'Pendiente', cls: 'bg-muted text-muted-foreground' },
  activo: { label: 'Activo', cls: 'bg-green-100 text-green-700' },
  revision: { label: 'Revisión', cls: 'bg-amber-100 text-amber-700' },
  baja: { label: 'Baja', cls: 'bg-red-100 text-red-700' },
  no_inscrito: { label: 'Sin inscribir', cls: 'bg-muted/50 text-muted-foreground' },
}

const EstadoInscripcionBadge = ({ estado }) => {
  const e = ESTADOS[estado] || ESTADOS.no_inscrito
  return (
    <span className={`inline-flex rounded-full px-2 py-0.5 text-xs font-medium leading-none ${e.cls}`}>
      {e.label}
    </span>
  )
}

export default EstadoInscripcionBadge
